'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { MultiSelectList } from '@repo/ui/MultiSelectList'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const UserMultiSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx
}) => {
  const { fetchAllUsers, allUsers } = useLookupsStore()
  const [options, setOptions] = useState(testData || allUsers || [])

  useEffect(() => {
    if (testData) return
    setOptions(allUsers || [])
  }, [testData, allUsers])

  useEffect(() => {
    if (testData || allUsers?.length) return
    fetchAllUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, allUsers])

  return (
    <div data-testid="UserMultiSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}>
      <MultiSelectList
        label="Users"
        onChange={onChange}
        labelKey="userId"
        valueKey="userId"
        idLabelKey="emailAddress"
        items={options}
        value={value}
        name="users"
        sx={sx}
      />
    </div>
  )
}

UserMultiSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool
}
